import React from 'react';
import WelcomeInfoLayoutDefault
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/WelcomeRework/WelcomeInfoLayoutDefault';

function WelcomeInfoLayoutWithBottomImage() {
  return (
    <WelcomeInfoLayoutDefault isImageAtTop={false} />
  );
}

WelcomeInfoLayoutWithBottomImage.propTypes = {};

WelcomeInfoLayoutWithBottomImage.defaultProps = {};

export default WelcomeInfoLayoutWithBottomImage;
